import { Injectable } from '@angular/core';
import { LogService} from 'app/_services/logmanager.service';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { GlobalsService } from 'app/_services/globals.service';

@Injectable()
export class NeedSearchUserGuard implements CanActivate {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private globalStorage: GlobalsService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        LogService.log('NeedSearchUserGuard', 'canActivate');

        const searchUser = this.globalStorage.getItem('searchUser');
        if (!searchUser) {
            LogService.log('NeedSearchUserGuard', 'No user. Redirecting to search form');

            const url = state.url.split('?');

            this.globalStorage.setItems([
                {name: 'returnUrl', value: url[0]},
                {name: 'navigationExtras', value: JSON.stringify(route.queryParams)}
            ]).then(() => {
                this.router.navigate(['/filtres-alumnes']);
            });
        }
        return searchUser !== '';
    }
}
